import { FormikField } from 'components/common/form/field/FormikField';
import i18n from 'i18n';
import styles from './adDeclarationForm.module.scss';

export const AdDeclarationForm: React.FC<{
  disabled?: boolean;
}> = ({ disabled = false }) => {
  return (
    <fieldset>
      <legend>
        <span>{i18n.t('adDeclarationForm.labels.title')}</span>
      </legend>
      <div className={styles.component}>
        <FormikField.FileInput
          name='adDeclaration'
          type='other'
          disabled={disabled}
          validTypes={[
            'application/pdf',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
          ]}
          hints={[
            i18n.t('outdoorForm.hints.selfCheckFileType'),
            i18n.t('creativeSetupFlow.labels.storageHint', {
              storage: '5MB'
            })
          ]}
        />
      </div>
    </fieldset>
  );
};
